export default {
  common: {
    home: 'Startseite',
    booking: 'Buchung',
    appointments: 'Termine',
    settings: 'Einstellungen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    back: 'Zurück',
    continue: 'Weiter',
    confirm: 'Bestätigen',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',
    date: 'Datum',
    time: 'Uhrzeit',
    status: 'Status',
    service: 'Service',
    store: 'Filiale',
    all: 'Alle',
    search: 'Suche',
    view: 'Ansehen',
    edit: 'Bearbeiten',
    actions: 'Aktionen',
    delete: 'Löschen',
    saving: 'Speichern...',
    deleting: 'Löschen...',
    backToHome: 'Zurück zur Startseite'
  },
  home: {
    hero: {
      title: 'Willkommen auf unserer Buchungsplattform',
      subtitle: 'Buchen Sie Ihren Termin mit wenigen Klicks',
      cta: 'Jetzt buchen'
    },
    howItWorks: {
      title: 'Wie funktioniert es?',
      step1: {
        title: '1. Wählen Sie Ihre Filiale',
        description: 'Wählen Sie die Filiale in Ihrer Nähe'
      },
      step2: {
        title: '2. Wählen Sie einen Termin',
        description: 'Wählen Sie Datum und Uhrzeit, die Ihnen passen'
      },
      step3: {
        title: '3. Bestätigen Sie Ihren Termin',
        description: 'Erhalten Sie eine Bestätigung per E-Mail'
      }
    },
    advantages: {
      title: 'Warum uns wählen?',
      simple: {
        title: 'Einfach und schnell',
        description: 'Buchen Sie in weniger als 2 Minuten'
      },
      flexible: {
        title: 'Flexibel',
        description: 'Ändern oder stornieren Sie Ihren Termin einfach'
      },
      reminders: {
        title: 'Automatische Erinnerungen',
        description: 'Erhalten Sie E-Mail-Benachrichtigungen'
      }
    }
  },
  stores: {
    title: 'Unsere Filialen',
    comingSoon: 'Demnächst',
    availableServices: 'Verfügbare Dienste',
    bookNow: 'Jetzt Buchen',
    selectStore: 'Filiale auswählen',
    noStores: 'Keine Filialen verfügbar',
    noStoresFound: 'Keine Filialen gefunden',
    closed: 'Geschlossen',
    manage: 'Filialen verwalten',
    addStore: 'Filiale hinzufügen',
    editStore: 'Filiale bearbeiten',
    city: 'Stadt',
    cityKey: 'Stadt-Schlüssel',
    name: 'Name',
    address: 'Adresse',
    zip: 'PLZ',
    phone: 'Telefon',
    email: 'E-Mail',
    workingHours: 'Öffnungszeiten',
    isOpen: 'Geöffnet',
    isActive: 'Aktiv',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    confirmDelete: 'Löschen bestätigen',
    deleteWarning: 'Sind Sie sicher, dass Sie diese Filiale löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    loadError: 'Fehler beim Laden der Filialen',
    saveError: 'Fehler beim Speichern der Filiale',
    deleteError: 'Fehler beim Löschen der Filiale',
    createSuccess: 'Filiale erfolgreich erstellt',
    updateSuccess: 'Filiale erfolgreich aktualisiert',
    deleteSuccess: 'Filiale erfolgreich gelöscht'
  },
  services: {
    title: 'Unsere Dienstleistungen',
    escooter: {
      title: 'Elektroroller',
      description: 'Vermietung und Wartung von Elektrorollern'
    },
    emotorcycle: {
      title: 'Elektromotorräder',
      description: 'Vermietung und Wartung von Elektromotorrädern'
    },
    ebike: {
      title: 'E-Bikes',
      description: 'Vermietung und Wartung von E-Bikes'
    },
    repair: 'Reparatur',
    trial: 'Probefahrt',
    trial_description: 'Testen Sie unsere Elektrofahrzeuge',
    repair_description: 'Reparatur- und Wartungsservice',
    selectService: 'Service auswählen',
    TRIAL: 'Probefahrt',
    REPAIR: 'Reparaturservice'
  },
  booking: {
    storeClosed: "Das Geschäft ist an diesem Tag geschlossen",
    title: 'Termin buchen',
    selectStore: 'Diese Filiale auswählen',
    steps: {
      store: 'Filiale',
      service: 'Service',
      datetime: 'Datum & Zeit',
      info: 'Information'
    },
    selectDate: 'Datum auswählen',
    selectTime: 'Uhrzeit auswählen',
    personalInfo: 'Ihre Informationen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    comments: 'Kommentare (optional)',
    submit: 'Termin bestätigen',
    success: 'Buchung bestätigt',
    error: 'Buchungsfehler',
    confirmationTitle: 'Buchungsbestätigung',
    confirmationMessage: 'Ihr Termin wurde erfolgreich gebucht. Sie erhalten in Kürze eine Bestätigungs-E-Mail.',
    details: 'Termindetails',
    addToCalendar: 'Zum Kalender hinzufügen',
    addToGoogle: 'Zu Google Kalender hinzufügen',
    addToApple: 'Zu Apple Kalender hinzufügen',
    noAvailableSlots: "Keine verfügbaren Termine für dieses Datum",
    weekDays: {
      mon: 'Mo',
      tue: 'Di',
      wed: 'Mi',
      thu: 'Do',
      fri: 'Fr',
      sat: 'Sa',
      sun: 'So'
    },
    months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember'
    }
  },
  appointment: {
    details: 'Termindetails',
    management: 'Terminverwaltung',
    description: 'Verwalten Sie alle Kundentermine',
    new: 'Neuer Termin',
    client: 'Kunde',
    noAppointments: 'Keine Termine gefunden',
    searchPlaceholder: 'Suche nach Name, E-Mail oder Telefon...',
    status: {
      pending: 'Ausstehend',
      confirmed: 'Bestätigt',
      cancelled: 'Storniert'
    },
    actions: {
      cancel: 'Termin stornieren',
      reschedule: 'Termin verschieben'
    }
  },
  errors: {
    404: {
      title: 'Seite nicht gefunden',
      message: 'Entschuldigung, die gesuchte Seite existiert nicht oder wurde verschoben.',
      backHome: 'Zurück zur Startseite'
    },
    generic: {
      title: 'Ein Fehler ist aufgetreten',
      message: 'Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es später erneut.',
      retry: 'Erneut versuchen'
    }
  },
  days: {
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag'
  },
  admin: {
    title: 'Administration',
    dashboard: {
      title: 'Dashboard',
      stats: {
        stores: 'Filialen',
        employees: 'Mitarbeiter',
        services: 'Dienstleistungen'
      },
      appointmentsPerDay: 'Termine pro Tag',
      appointmentsPerStore: 'Termine pro Filiale',
      chartComingSoon: 'Diagramm in Kürze verfügbar',
      recentAppointments: 'Aktuelle Termine',
      noAppointments: 'Keine Termine',
      table: {
        date: 'Datum',
        time: 'Uhrzeit',
        store: 'Filiale',
        client: 'Kunde',
        status: 'Status',
        service: 'Dienstleistung'
      }
    },
    stores: {
      title: 'Filialverwaltung',
      addStore: 'Filiale hinzufügen',
      editStore: 'Filiale bearbeiten',
      deleteStore: 'Filiale löschen',
      city: 'Stadt',
      cityKey: 'Stadt-Schlüssel',
      name: 'Name',
      address: 'Adresse',
      zip: 'PLZ',
      phone: 'Telefon',
      email: 'E-Mail',
      status: 'Status',
      services: 'Dienstleistungen',
      workingHours: 'Öffnungszeiten',
      isOpen: 'Geöffnet',
      isActive: 'Aktiv',
      isComingSoon: 'Demnächst',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      confirmDelete: 'Löschen bestätigen',
      deleteWarning: 'Sind Sie sicher, dass Sie diese Filiale löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      loadError: 'Fehler beim Laden der Filialen',
      saveError: 'Fehler beim Speichern der Filiale',
      deleteError: 'Fehler beim Löschen der Filiale',
      createSuccess: 'Filiale erfolgreich erstellt',
      updateSuccess: 'Filiale erfolgreich aktualisiert',
      deleteSuccess: 'Filiale erfolgreich gelöscht',
      noStores: 'Keine Filialen gefunden',
      form: {
        name: 'Name',
        city: 'Stadt',
        selectCity: 'Stadt auswählen',
        address: 'Adresse',
        zipCode: 'PLZ',
        services: 'Dienstleistungen',
        status: 'Status'
      }
    },
    employees: {
      title: 'Mitarbeiterverwaltung',
      addEmployee: 'Mitarbeiter hinzufügen',
      editEmployee: 'Mitarbeiter bearbeiten',
      deleteEmployee: 'Mitarbeiter löschen',
      name: 'Name',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      store: 'Filiale',
      password: 'Passwort',
      status: 'Status',
      isActive: 'Aktiv',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      noStore: 'Keine Filiale',
      leaveBlankPassword: 'Leer lassen, um aktuelles Passwort beizubehalten',
      noEmployees: 'Keine Mitarbeiter gefunden',
      confirmDelete: 'Löschen bestätigen',
      deleteWarning: 'Sind Sie sicher, dass Sie diesen Mitarbeiter löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      loadError: 'Fehler beim Laden der Mitarbeiter',
      saveError: 'Fehler beim Speichern des Mitarbeiters',
      deleteError: 'Fehler beim Löschen des Mitarbeiters',
      createSuccess: 'Mitarbeiter erfolgreich erstellt',
      updateSuccess: 'Mitarbeiter erfolgreich aktualisiert',
      deleteSuccess: 'Mitarbeiter erfolgreich gelöscht',
      form: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        store: 'Filiale',
        selectStore: 'Filiale auswählen',
        role: 'Rolle',
        status: 'Status'
      }
    }
  },
  roles: {
    manager: 'Filialleiter',
    mechanic: 'Mechaniker',
    apprentice: 'Auszubildender'
  },
  auth: {
    login: {
      title: 'Anmelden',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      rememberMe: 'Angemeldet bleiben',
      forgotPassword: 'Passwort vergessen?',
      submit: 'Anmelden',
      loggingIn: 'Anmeldung läuft...',
      errors: {
        emailRequired: 'E-Mail-Adresse ist erforderlich',
        emailInvalid: 'E-Mail-Adresse ist ungültig',
        passwordRequired: 'Passwort ist erforderlich',
        default: 'Ungültige Anmeldedaten'
      }
    },
    logout: 'Abmelden'
  }
} 